















import { Component, Vue } from "vue-property-decorator";
import { ManualModel } from "../models";

@Component
export default class AddManual extends Vue {
  private newManual() {
    this.$emit("openManualDialog", new ManualModel(), true);
  }
}
